'use client';

import { SidebarDrawer } from 'templates/PageTemplate/Sidebar/SidebarDrawer';
import { NavigationItem } from 'templates/PageTemplate/Sidebar/SidebarNavigation/NavigationItem';
import { parseItems } from 'templates/PageTemplate/Sidebar/SidebarNavigation/helpers';
import { Icon, IconType } from 'atoms/Icon';
import { useTranslations } from 'modules/i18n/useTranslations';
import { usePopoverManager } from 'modules/shop/popoverManager/hooks';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import { SidebarButtons } from './SidebarButtons';
import { useMultiLvlNavigation } from './hooks';
import styles from './SidebarNavigation.module.css';

export const SidebarNavigation = () => {
  const { header } = useSiteConfig();
  const { nextLvlList, addNewLvl, back, breadcrumbs } = useMultiLvlNavigation();
  const { closePopover } = usePopoverManager();
  const t = useTranslations();

  return (
    <div className={styles.root}>
      {header?.children
        ?.filter((c) => !c.disableForLocale)
        ?.map((navigationItem) => {
          const url = (
            navigationItem?.url?.story?.full_slug ||
            navigationItem?.url?.cached_url
          )?.replace(/^\/+/, '');

          return (
            <NavigationItem
              title={navigationItem.title}
              url={url}
              key={navigationItem._uid}
              backgroundColor={navigationItem.color?.color}
              onClick={() => addNewLvl(navigationItem)}
              className={styles.firstLvlItem}
              breadcrumbs={breadcrumbs}
              hasChildren={!!navigationItem?.flyoutColumns?.length}
            />
          );
        })}

      {nextLvlList.map((lvl, i) => {
        const url = (
          lvl?.url?.story?.full_slug || lvl?.url?.cached_url
        )?.replace(/^\/+/, '');

        return (
          <SidebarDrawer
            key={`${i}_key`} // non-dynamic key needed for animation, uuid, Math.random, _uid - not working
            open={!!lvl?._uid}
            onClose={closePopover}
          >
            <div className={styles.back} onClick={back}>
              <Icon type={IconType.arrowDown} className={styles.iconBack} />
              {t('product.pdp.footer.back')}
            </div>
            <div className={styles.title}>{lvl.title}</div>
            <div className={styles.root}>
              {/* All Category link*/}
              {breadcrumbs.length >= 2 && (
                <NavigationItem
                  url={url}
                  title={t('header.navigation.all', {
                    categoryName: lvl.title,
                  })}
                  className={styles.secondLvlItem}
                />
              )}

              {parseItems(lvl)?.map((navigationItem) => {
                const url = (
                  navigationItem?.url?.story?.full_slug ||
                  navigationItem?.url?.cached_url
                )?.replace(/^\/+/, '');

                return (
                  <NavigationItem
                    key={navigationItem._uid}
                    title={navigationItem.title}
                    url={url}
                    onClick={() => addNewLvl(navigationItem)}
                    className={styles.secondLvlItem}
                    breadcrumbs={breadcrumbs}
                    hasChildren={!!navigationItem?.children?.length}
                  />
                );
              })}
            </div>
            <SidebarButtons />
          </SidebarDrawer>
        );
      })}
    </div>
  );
};
